import React from 'react'
import { NavLink } from 'react-router-dom'
function GeneralSetting() {
    return (
        <>
   <div className="mt-5">
  <h5>General</h5>
  <div className="email-menu-list labels-list">
    <NavLink to="/company" className="text-info font-600 ">Company</NavLink>
    <NavLink to="/locations" className="text-info font-600">Locations</NavLink>
    <NavLink to="/departments" className="text-info font-600 ">Departments</NavLink>
    <NavLink to="/sub-departments" className="text-info font-600">Sub Departments</NavLink>
    <a href="teams.html" className="text-info font-600">Teams</a>
    <a href="business-units.html" className="text-info font-600">Business Units</a>
    <a href="preferences.html" className="text-info font-600">Preferences</a>
  </div>
</div>

        </>
    )
}

export default GeneralSetting
